import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.header`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 4rem;
	background-color: #ffffff;
	color: black;
	width: 100%;
	padding: 0 4rem;
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	z-index: 999;
	margin: 0 auto;

	@media (max-width: 1000px) {
		padding: 0 1rem;
	}
`;

const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	padding-left: 1rem;

	img {
		width: 100%;
		height: 37.9px;
		object-fit: cover;
	}
`;

const NavLinks = styled.div`
	display: flex;
	align-items: center;
	padding-right: 1rem;
	gap: 2.25rem;
	white-space: nowrap;
	& > * {
		cursor: pointer;
		color: inherit; /* 기본 색상 유지 */
		transition: color 0.3s;

		&:hover {
			color: black; /* 호버 시 검은색으로 변경 */
			font-weight: 300;
		}
	}

	@media (max-width: 1000px) {
		display: none;
	}
`;

const ButtonGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;

	button {
		background-color: #2c2c2c;
		color: #ffffff;
		padding: 0.5rem 2.5rem;
		width: 10rem;
		height: 100%;
		border-radius: 0.2rem;
		border: none;
		cursor: pointer;
		transition: background-color 0.3s;

		&:hover {
			background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1)); /* 호버 효과 */
		}
	}

	@media (max-width: 1000px) {
		display: none;
	}
`;

const MoblieButton = styled.div`
	background-color: #2c2c2c;
	color: #ffffff;
	padding: 0.5rem 2.5rem;
	width: 10rem;
	height: 100%;
	border-radius: 0.2rem;
	border: none;
	display: flex;
	justify-content: center;
`;

const HamburgerMenu = styled.div`
	display: none;
	cursor: pointer;
	font-size: 2rem;

	@media (max-width: 1000px) {
		display: block;
	}
`;

const MobileNavLinks = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center; /* 가운데 정렬 추가 */
	justify-content: center; /* 수직 가운데 정렬 추가 */
	position: absolute;
	top: 4rem;
	right: 0;
	background-color: #ffffff;
	width: 100%;
	padding: 1rem;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	white-space: nowrap;
	gap:10px;

	a,
	button {
		margin-bottom: 1rem;
		text-align: center;
	}

	@media (min-width: 1000px) {
		display: none;
	}
`;

const StyledNickname = styled.span`
	font-size: 1.25rem;
	color: #2c2c2c;
	margin-right: 2rem;
	white-space:nowrap;
`;

export default function Header() {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false); // 로그인 상태 관리
	const [nickname, setNickname] = useState<string | null>(null); // 사용자 닉네임 관리
	const navigate = useNavigate();

	useEffect(() => {
		// 로컬 스토리지에서 로그인 정보 확인
		const storedLogin = localStorage.getItem('login');
		const storedUser = localStorage.getItem('user');

		if (storedLogin) {
			
			setIsLoggedIn(true);
		}

		if (storedUser) {
			const userInfo = JSON.parse(storedUser);
			
			setNickname(userInfo.nickname); // 닉네임 설정
		}
	}, []);

	const handleLogout = () => {
		localStorage.clear();
		setIsLoggedIn(false);
		setNickname(null);
		console.log('Logged out');
		navigate('/');
	};

	return (
		<HeaderContainer>
			<div
				className="flex items-center gap-12"
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					width: '100%',
					alignItems: 'center',
				}}
			>
				<Link to={`/`}>
					<LogoContainer>
						<img alt="Logo" src="/icons/logo.svg" />
					</LogoContainer>
				</Link>

				<NavLinks>
					<Link to={`/diagnosis/list`}>
						<span>진단</span>
					</Link>
					<Link to={`/diagnosis/dictionary`}>
						<span>바야위키</span>
					</Link>
					{/* <Link to={`/diagnosis/my`}>
						<span>마이페이지</span>
					</Link> */}
				</NavLinks>

				<HamburgerMenu onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
					<span>☰</span>
				</HamburgerMenu>

				<ButtonGroup>
					{isLoggedIn ? (
						<>
							<StyledNickname>{nickname}님</StyledNickname> {/* 닉네임 표시 */}
							<button onClick={handleLogout}>로그아웃</button>
						</>
					) : (
						<>
							<button onClick={() => navigate('/auth')}>로그인</button>
							<button onClick={() => navigate('/auth/signup')}>회원가입</button>
						</>
					)}
				</ButtonGroup>
			</div>

			{isMobileMenuOpen && (
				<MobileNavLinks>
					<Link to={`/diagnosis/list`}>진단</Link>
					<Link to={`#`}>콘텐츠</Link>
					<Link to={`#`}>우리동네탈모성지</Link>
					<Link to={`/diagnosis/dictionary`}>바야위키</Link>
					<Link to={`#`}>마이페이지</Link>
					{isLoggedIn ? (
						<>
							<span>{nickname}님</span> {/* 닉네임 표시 */}
							<MoblieButton onClick={handleLogout}>로그아웃</MoblieButton>
						</>
					) : (
						<>
							<MoblieButton onClick={() => navigate('/auth')}>로그인</MoblieButton>
							<MoblieButton>회원가입</MoblieButton>
						</>
					)}
				</MobileNavLinks>
			)}
		</HeaderContainer>
	);
}
